// extracted by mini-css-extract-plugin
module.exports = {"categorynav":"categorynav_categorynav__2dBCd","active":"categorynav_active__S7vJU"};